<template>
    <div>
        <div class="row" v-if="hideData">
            <div class="col-xs-12 col-sm-9">
                <p>
                    {{ $t('MEDICAL_DATA_INFO') }}
                </p>
            </div>
            <div class="col-xs-12 col-sm-3">
                <button class="app-btn app-btn-primary pull-right" @click="hideData = !hideData">
                    {{ $t('CHECK_DATA') }}
                </button>
            </div>
        </div>

        <div v-else class="data-details">
            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step4q1 === false">
                    <label>{{ $t('BREAST_SIZE_IN_BRASTER') }}</label>
                    <br />
                    <span class="text-input white-input-border disabled">{{ survey.section4.q1 }}</span>
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--Rozmiar piersi -->
                            <survey-step4-q1
                                :single="true"
                                @cancel="submitEditing(false)"
                                @save="submitEditing(true)"
                            ></survey-step4-q1>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step4q1 = true" v-if="step4q1 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />

            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step4q2 === false">
                    <label>{{ $t('DO_YOU_MENSTRUATE_REGULARLY') }} </label>
                    <br />
                    <span class="text-input white-input-border disabled">{{ $t(survey.section4.q2) }}</span>
                    <br />
                    <span v-if="survey.section4.q2 === 'YES'" class="text-input white-input-border disabled">{{
                        $t('AVERAGE_CYCLE_LENGTH', { number: this.q2_1 })
                    }}</span>
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--Rozmiar piersi -->
                            <survey-step4-q2
                                :single="true"
                                @cancel="submitEditing(false)"
                                @save="submitEditing(true)"
                            ></survey-step4-q2>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step4q2 = true" v-if="step4q2 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />
            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step4q3 === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('DO_YOU_HAVE_THYROID_DISEASE') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ $t(survey.section4.q3) }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!-- Zaznacz choroby na które chorujesz -->
                            <survey-step4-q3
                                :single="true"
                                @cancel="submitEditing(false)"
                                @save="submitEditing(true)"
                            ></survey-step4-q3>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step4q3 = true" v-if="step4q3 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />
            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step4q4 === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('STRUCTURE_OF_YOUR_BREASTS') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ $t(survey.section4.q4) }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!-- Zaznacz choroby na które chorujesz -->
                            <survey-step4-q4
                                :single="true"
                                @cancel="submitEditing(false)"
                                @save="submitEditing(true)"
                            ></survey-step4-q4>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step4q4 = true" v-if="step4q4 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />
            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q9 === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('DO_YOU_HAVE_IMPLANTS') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ $t(survey.section3.q10) }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--7/7 | Czy masz blizny na piersiach-->
                            <survey-step3-q9
                                :single="true"
                                @cancel="submitEditing(false)"
                                @save="submitEditing(true)"
                            ></survey-step3-q9>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q9 = true" v-if="step3q9 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />
            <button class="app-btn app-btn-primary pull-right" @click="collapse">{{ $t('COLLAPSE') }}</button>
        </div>
    </div>
</template>

<script>
import { mapFromMedicalData, mapMedicalData } from './../../../main';
import { mapGetters } from 'vuex';
import surveyStep3Q5 from '../../modals/main-survey/survey-step3-q5.vue';
import surveyStep4Q1 from '../../modals/main-survey/survey-step4-q1.vue';
import surveyStep4Q2 from '../../modals/main-survey/survey-step4-q2.vue';
import surveyStep4Q3 from '../../modals/main-survey/survey-step4-q3.vue';
import surveyStep4Q4 from '../../modals/main-survey/survey-step4-q4.vue';
import surveyStep3Q9 from '../../modals/main-survey/survey-step3-q9.vue';
import Vue from 'vue';

export default {
    data() {
        return {
            hideData: true,
            step3q5: false,
            step4q1: false,
            step4q2: false,
            step4q2_1: false,
            step4q3: false,
            step4q4: false,
            step3q9: false,
        };
    },
    methods: {
        collapse() {
            this.hideData = true;
            this.$scrollTo('#DaneMedyczne', 500, { offset: -30 });
        },
        submitEditing(submitData) {
            this.step3q5 = false;
            this.step4q1 = false;
            this.step4q2 = false;
            this.step4q2_1 = false;
            this.step4q3 = false;
            this.step4q4 = false;
            this.step3q9 = false;
            if (submitData) {
                mapMedicalData();
                Vue.http.post('/openehr/api/composition/', this.$store.state.medicalData);
            } else {
                mapFromMedicalData();
            }
        },
    },
    computed: {
        ...mapGetters({
            survey: 'survey',
        }),
        q2_1() {
            return this.$store.getters.survey.section4.q2_1;
        },
    },
    components: {
        surveyStep3Q5,
        surveyStep4Q1,
        surveyStep4Q2,
        surveyStep4Q3,
        surveyStep4Q4,
        surveyStep3Q9,
    },
};
</script>

<style scoped>
.row-flex-align-bottom {
    display: flex;
    flex-wrap: wrap;
}

.row-flex-align-bottom > div a {
    cursor: pointer;
    display: block;
    margin-bottom: 15px;
}

.row-flex-align-bottom > div {
    align-self: flex-end;
}

label {
    font-size: 16px;
    font-weight: 400;
}

.data-details {
    margin-bottom: 100px;
}

.arrow-img {
    height: 7px;
    margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// medical-data.vue?345ff39d